import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Manifesto from "@/components/landing/Manifesto";
import DualFeed from "@/components/landing/DualFeed";
import Monetization from "@/components/landing/Monetization";
import AITravel from "@/components/landing/AITravel";
import MarketCommunities from "@/components/landing/MarketCommunities";
import Privacy from "@/components/landing/Privacy";
import Comparison from "@/components/landing/Comparison";
import Investors from "@/components/landing/Investors";
import CTAFooter from "@/components/landing/CTAFooter";
import { useSiteConfig } from "@/context/SiteConfigContext";

const SECTION_MAP = {
  hero: Hero,
  manifesto: Manifesto,
  dual_feed: DualFeed,
  monetization: Monetization,
  ai_travel: AITravel,
  market_communities: MarketCommunities,
  privacy: Privacy,
  comparison: Comparison,
  investors: Investors,
  cta_footer: CTAFooter,
};

const ORDER = ["hero", "manifesto", "dual_feed", "monetization", "ai_travel",
                "market_communities", "privacy", "comparison", "investors", "cta_footer"];

export default function Landing() {
  const { config } = useSiteConfig();
  const visible = config?.landing?.sections_visible || {};
  return (
    <main data-testid="landing-page" className="bg-cream text-ink">
      <Header />
      {ORDER.map((id) => {
        if (visible[id] === false) return null;
        const Cmp = SECTION_MAP[id];
        return Cmp ? <Cmp key={id} /> : null;
      })}
    </main>
  );
}
